function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.83152 7.83148C7.90117 7.76174 7.98389 7.70642 8.07494 7.66868C8.16599 7.63094 8.26358 7.61151 8.36214 7.61151C8.46071 7.61151 8.5583 7.63094 8.64935 7.66868C8.7404 7.70642 8.82312 7.76174 8.89277 7.83148L11.7803 10.719C11.921 10.8596 12.0001 11.0504 12.0002 11.2493C12.0002 11.4483 11.9213 11.6391 11.7806 11.7799C11.64 11.9206 11.4492 11.9997 11.2503 11.9998C11.0513 11.9998 10.8605 11.9209 10.7198 11.7802L7.83227 8.89273C7.76254 8.82307 7.70722 8.74036 7.66948 8.64931C7.63173 8.55826 7.6123 8.46066 7.6123 8.3621C7.6123 8.26354 7.63173 8.16594 7.66948 8.0749C7.70722 7.98385 7.76254 7.90113 7.83227 7.83148H7.83152Z",
  fill: "#828282"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.875 9C5.4167 9 5.9531 8.8933 6.45357 8.686C6.95404 8.4787 7.40877 8.17486 7.79182 7.79182C8.17486 7.40877 8.4787 6.95404 8.686 6.45357C8.8933 5.9531 9 5.4167 9 4.875C9 4.3333 8.8933 3.7969 8.686 3.29643C8.4787 2.79596 8.17486 2.34123 7.79182 1.95818C7.40877 1.57514 6.95404 1.2713 6.45357 1.064C5.9531 0.856696 5.4167 0.75 4.875 0.75C3.78098 0.75 2.73177 1.1846 1.95818 1.95818C1.1846 2.73177 0.75 3.78098 0.75 4.875C0.75 5.96902 1.1846 7.01823 1.95818 7.79182C2.73177 8.5654 3.78098 9 4.875 9ZM9.75 4.875C9.75 6.16793 9.23639 7.40791 8.32215 8.32215C7.40791 9.23639 6.16793 9.75 4.875 9.75C3.58207 9.75 2.34209 9.23639 1.42785 8.32215C0.513615 7.40791 0 6.16793 0 4.875C0 3.58207 0.513615 2.34209 1.42785 1.42785C2.34209 0.513615 3.58207 0 4.875 0C6.16793 0 7.40791 0.513615 8.32215 1.42785C9.23639 2.34209 9.75 3.58207 9.75 4.875Z",
  fill: "#828282"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.b60c4c73.svg";
export { ForwardRef as ReactComponent };